import { render, staticRenderFns } from "./ring-graph.vue?vue&type=template&id=1c3afcda&scoped=true"
import script from "./ring-graph.vue?vue&type=script&lang=ts"
export * from "./ring-graph.vue?vue&type=script&lang=ts"
import style0 from "./ring-graph.vue?vue&type=style&index=0&id=1c3afcda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3afcda",
  null
  
)

export default component.exports